import type { ReactNode } from 'react';
import { cn } from './cn';

/**
 * "Nothing here" — a tag with no stories, a search with no results. Distinct from
 * `<ErrorState>` on purpose: an empty result is a true answer and must not look like a
 * failure, or readers retry something that worked.
 */
export function EmptyState({
  title,
  body,
  action,
  className,
}: {
  title: string;
  body?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-3 rounded-lg border border-line bg-soft px-6 py-12 text-center',
        className,
      )}
    >
      <svg
        viewBox="0 0 24 24"
        width="28"
        height="28"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        className="text-muted"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="7" />
        <path d="m21 21-4.3-4.3" />
      </svg>
      <h3 className="text-xl font-extrabold">{title}</h3>
      {body && <p className="max-w-sm text-base text-body">{body}</p>}
      {action}
    </div>
  );
}
